<div class="d-grid gap-3" style="grid-template-columns: 350px 1fr" *ngIf="viewType !== 'table'">
  <app-automation-wizard-left
    [type]="type"
    (typeChange)="typeChange.emit($event)"
    image="/assets/images/automation-wizards/task.webp"
  >
    <ng-container i18n
      >A task is a specific action or set of actions assigned to staff or team members within the property management
      system. It can involve setting or updating rental statuses, notifying relevant parties, and escalating issues when
      overdue or reassigned. Tasks help ensure responsibilities are tracked and completed efficiently.</ng-container
    >
  </app-automation-wizard-left>
  <div class="card shadow">
    <div class="card-header flex-column align-items-start p-3 bg-default2">
      <h6 i18n>What would you like to do when a task is</h6>
      <div class="btn-group">
        <button
          type="button"
          (click)="onSelectEvent(events.TaskCreated)"
          class="btn btn-sm"
          [ngClass]="selectedEvent === events.TaskCreated ? 'btn-info' : 'btn-outline-light'"
          i18n
        >
          Created
        </button>
        <button
          type="button"
          (click)="onSelectEvent(events.TaskCompleted)"
          class="btn btn-sm"
          [ngClass]="selectedEvent === events.TaskCompleted ? 'btn-info' : 'btn-outline-light'"
          i18n
        >
          Completed</button
        ><button
          type="button"
          (click)="onSelectEvent(events.TaskOverdue)"
          class="btn btn-sm"
          [ngClass]="selectedEvent === events.TaskOverdue ? 'btn-info' : 'btn-outline-light'"
          i18n
        >
          Overdue
        </button>
        <button
          type="button"
          (click)="onSelectEvent(events.TaskReassigned)"
          class="btn btn-sm"
          [ngClass]="selectedEvent === events.TaskReassigned ? 'btn-info' : 'btn-outline-light'"
          i18n
        >
          Reassigned
        </button>
      </div>
    </div>
    <div class="card-body d-flex flex-column gap-3">
      <ng-container [ngSwitch]="selectedEvent">
        <ng-template *ngSwitchCase="events.TaskCreated" [ngTemplateOutlet]="createdEvent"> </ng-template>
        <ng-template *ngSwitchCase="events.TaskCompleted" [ngTemplateOutlet]="completedEvent"> </ng-template>
        <ng-template *ngSwitchCase="events.TaskOverdue" [ngTemplateOutlet]="overdueEvent"> </ng-template>
        <ng-template *ngSwitchCase="events.TaskReassigned" [ngTemplateOutlet]="reassignedEvent"> </ng-template>
      </ng-container>

      <div class="flex-fill"></div>
      <app-automation-channel-rental-select
        [form]="form"
        [allowsChannel]="false"
      ></app-automation-channel-rental-select>
    </div>
  </div>
</div>

<div *ngIf="viewType === 'table'" class="d-flex flex-column gap-4 automation-table">
  <div class="table-view-header text-muted text-semi-bold">
    <div class="text-uppercase text-muted mb-0" i18n>What would you like to do when</div>
    <div i18n>Created Date • Time</div>
    <div i18n>Last Triggered Date • Time</div>
  </div>
  <div class="container-box shadow">
    <h6 class="text-uppercase m-0 px-3 py-2" i18n>Task is Created</h6>
    <ng-template [ngTemplateOutlet]="createdEvent"></ng-template>
  </div>
  <div class="container-box shadow">
    <h6 class="text-uppercase m-0 px-3 py-2" i18n>Task is Completed</h6>
    <ng-template [ngTemplateOutlet]="completedEvent"></ng-template>
  </div>
  <div class="container-box shadow">
    <h6 class="text-uppercase m-0 px-3 py-2" i18n>Task is Overdue</h6>
    <ng-template [ngTemplateOutlet]="overdueEvent"></ng-template>
  </div>
  <div class="container-box shadow">
    <h6 class="text-uppercase m-0 px-3 py-2" i18n>Task is Reassigned</h6>
    <ng-template [ngTemplateOutlet]="reassignedEvent"></ng-template>
  </div>
</div>

<ng-template #createdEvent>
  <app-notify-handler-automation
    [event]="events.TaskCreated"
    [handler]="eventHandlers.TaskNotifyAssignee"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Notify the assignees"
    name="Notify the Assignee(s) when task is created"
    [messageSubject]="userNotificationMessages[events.TaskCreated].subject"
    [messageBody]="userNotificationMessages[events.TaskCreated].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-handler-automation>

  <app-do-action-automation
    [event]="events.TaskCreated"
    [handler]="eventHandlers.RentalMarkNotReadyHandler"
    [type]="automationTypes.Rental"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Set the rental status to Not Ready"
    name="Set the rental status to Not Ready when task created"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-do-action-automation>
  <app-do-action-automation
    [event]="events.TaskCreated"
    [type]="type"
    [viewType]="viewType"
    [eventSourceType]="type"
    [handler]="eventHandlers.SendToZapier"
    label="Send it to Zapier"
    name="Send it to Zapier when task created"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-do-action-automation>
</ng-template>

<ng-template #completedEvent>
  <app-do-action-automation
    [event]="events.TaskCompleted"
    [handler]="eventHandlers.RentalMarkReadyHandler"
    [type]="automationTypes.Rental"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Set the rental status to Ready"
    name="Set the rental status to Ready when task completed"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-do-action-automation>

  <app-notify-handler-automation
    [event]="events.TaskCompleted"
    [handler]="eventHandlers.TaskNotifyCreator"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Notify the task creator"
    name="Notify the task creator when task is completed "
    [messageSubject]="userNotificationMessages[events.TaskCompleted].subject"
    [messageBody]="userNotificationMessages[events.TaskCompleted].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-handler-automation>

  <app-do-action-automation
    [event]="events.TaskCompleted"
    [handler]="eventHandlers.TaskMarkIncidentResolved"
    [type]="type"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Mark associated incident as resolved"
    name="Mark associated incident as resolved when task completed"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-do-action-automation>
  <app-do-action-automation
    [event]="events.TaskCompleted"
    [type]="type"
    [viewType]="viewType"
    [eventSourceType]="type"
    [handler]="eventHandlers.SendToZapier"
    label="Send it to Zapier"
    name="Send it to Zapier when task completed"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-do-action-automation>
</ng-template>

<ng-template #overdueEvent>
  <app-notify-handler-automation
    [event]="events.TaskOverdue"
    [handler]="eventHandlers.TaskNotifyAssignee"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Notify the assigned user(s)"
    name="Notify the assigned staff. when task is overdue"
    [messageSubject]="userNotificationMessages[events.TaskOverdue].subject"
    [messageBody]="userNotificationMessages[events.TaskOverdue].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-handler-automation>
  <app-do-action-automation
    [event]="events.TaskOverdue"
    [type]="type"
    [viewType]="viewType"
    [eventSourceType]="type"
    [handler]="eventHandlers.SendToZapier"
    label="Send it to Zapier"
    name="Send it to Zapier when task overdue"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-do-action-automation>
</ng-template>

<ng-template #reassignedEvent>
  <app-notify-handler-automation
    [event]="events.TaskReassigned"
    [handler]="eventHandlers.TaskNotifyAssignee"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Notify new Assignees"
    name="Notify the new Assignee(s) when task is reassigned"
    [messageSubject]="userNotificationMessages[events.TaskReassigned].subject"
    [messageBody]="userNotificationMessages[events.TaskReassigned].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-handler-automation>

  <app-notify-handler-automation
    [event]="events.TaskReassigned"
    [handler]="eventHandlers.TaskNotifyOldAssignee"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Notify old Assignees"
    name="Notify the old Assignee(s) when task is reassigned"
    [messageSubject]="userNotificationMessages[events.TaskReassigned + '-old'].subject"
    [messageBody]="userNotificationMessages[events.TaskReassigned + '-old'].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-handler-automation>
  <app-do-action-automation
    [event]="events.TaskReassigned"
    [type]="type"
    [viewType]="viewType"
    [eventSourceType]="type"
    [handler]="eventHandlers.SendToZapier"
    label="Send it to Zapier"
    name="Send it to Zapier when task reassigned"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-do-action-automation>
</ng-template>
